// extracted by mini-css-extract-plugin
export default {"containerTrailer":"styles_containerTrailer__5AvxU","containerImg":"styles_containerImg__cDcrF"};